/* eslint-disable no-use-before-define */
import React from 'react'

export const Loading = () => {
    return <div data-name="loading-spinner" className="spinner" style={{width:'45px'}} aria-busy="true">
        <svg className="circular" viewBox="25 25 50 50">
        <circle className="background" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        <circle className="path" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        </svg>
        </div>
}



// WEBPACK FOOTER //
// ./src/municipals/map/tooltip/loading.js